import { Entity } from "./Entity";

export enum DumpsterSize {
  SIZE_10 = "10",
  SIZE_15 = "15",
  SIZE_CLEAN_FILL = "clean_fill",
}

export enum ServiceType {
  DUMPSTER = "dumpster",
  JUNK = "junk",
}

// Fleet-optimization waste type: which dump yards may accept a container's load.
export enum WasteType {
  TRASH = "trash",
  WOOD = "wood",
  CONCRETE = "concrete",
}

export enum MaterialDisposing {
  CONSTRUCTION = "construction",
  HOUSEHOLD = "household",
  HOUSEHOLD_CONSTRUCTION = "Household/Construction",
}

export enum CleanFillMaterialsDisposing {
  BRICK = "brick",
  BLOCK = "block",
  DIRT = "dirt",
  CONCRETE = "concrete",
  OTHER = "other",
}

export enum PaymentType {
  CASH = "cash",
  CARD = "card",
  CHECK = "check",
  PAYPAL = "paypal",
  VENMO = "venmo",
  OWES = "owes",
  ACH = "ach",
  CASH_APP = "cash_app",
  ZELLE = "zelle",
  APPLE_CASH = "apple_cash",
}

export enum OrderStatus {
  OrderStatusCreated = "created",
  OrderStatusScheduled = "scheduled",
  OrderStatusDelivered = "delivered",
  OrderStatusScheduledToPickup = "pickup_scheduled",
  OrderStatusPickedUp = "picked_up",
  OrderStatusComplete = "complete",
  OrderStatusCanceled = "canceled",
  OrderStatusReceived = "received",
}

export interface Order extends Entity {
  userId?: string;
  name: string;
  address: string;
  zip: string;
  phoneNumber: string;
  email: string;
  materialDisposing?: MaterialDisposing;
  description?: string;
  specialInstructions?: string;
  customerSpecialInstructions?: string;
  service: ServiceType;
  dumpsterSize?: DumpsterSize;
  dumpsterLabel?: string;
  dumpsterId?: string;
  deliveryDate: string;
  pickupDate: string;
  status: string;
  createdAt: string;
  price: number;
  deliveryFee: number;
  po?: string;
  discount: number;
  additionalCharges: number;
  paymentType?: PaymentType;
  city: string;
  latitude: number;
  longitude: number;
  // Marketing channel the order came through, derived from the landing-page
  // click ID. Set once at creation; the backend treats it as immutable.
  attributionSource?: string;
  attributionClickId?: string;
}

export const orderStatusToText: Record<OrderStatus, string> = {
  [OrderStatus.OrderStatusCreated]: "Created",
  [OrderStatus.OrderStatusScheduled]: "Scheduled",
  [OrderStatus.OrderStatusDelivered]: "Delivered",
  [OrderStatus.OrderStatusScheduledToPickup]: "Scheduled to pick up",
  [OrderStatus.OrderStatusPickedUp]: "Picked up",
  [OrderStatus.OrderStatusComplete]: "Complete",
  [OrderStatus.OrderStatusCanceled]: "Canceled",
  [OrderStatus.OrderStatusReceived]: "Received",
};

export const dumpsterSizeToText: Record<DumpsterSize, string> = {
  [DumpsterSize.SIZE_10]: "10 yards",
  [DumpsterSize.SIZE_15]: "15 yards",
  [DumpsterSize.SIZE_CLEAN_FILL]: "Clean Fill",
};

export const materialDisposingToText: Record<MaterialDisposing, string> = {
  [MaterialDisposing.CONSTRUCTION]: "Construction",
  [MaterialDisposing.HOUSEHOLD]: "Household",
  [MaterialDisposing.HOUSEHOLD_CONSTRUCTION]: "Mix",
};

export const dumpsterSizeToAllowedWeight: Record<DumpsterSize, number> = {
  [DumpsterSize.SIZE_10]: 4000,
  [DumpsterSize.SIZE_15]: 6000,
  [DumpsterSize.SIZE_CLEAN_FILL]: 6000,
};

export interface ActionInfo {
  driverName?: string;
  completedAt?: string;
  status: string;
  delivery_id?: string;
  pickup_id?: string;
  photo_s3_location?: string;
}

export interface OrderDetailsInfo {
  delivery?: ActionInfo;
  pickup?: ActionInfo;
}

export const paymentTypeToText: Record<PaymentType, string> = {
  [PaymentType.CASH]: "Cash",
  [PaymentType.CARD]: "Card",
  [PaymentType.CHECK]: "Check",
  [PaymentType.PAYPAL]: "PayPal",
  [PaymentType.VENMO]: "Venmo",
  [PaymentType.OWES]: "Owes",
  [PaymentType.ACH]: "ACH",
  [PaymentType.CASH_APP]: "Cash App",
  [PaymentType.ZELLE]: "Zelle",
  [PaymentType.APPLE_CASH]: "Apple Cash",
};
